import { config } from 'config';
import { restClient } from 'modules/shared/services/API/backend';
import { Category, GetCategory, SearchCategories } from '../../models';

export const categoryService = {
    get: async ({ id }: GetCategory) => {
        const response = await restClient.get<Category>(`${config.backend.rest.catalogueUrl}/category/${id}`);
        return response.data;
    },
    searchByName: async ({ keyword }: SearchCategories) => {
        const response = await restClient.get<Category[]>(
            `${config.backend.rest.catalogueUrl}/category?keyword=${keyword}`,
        );
        return response.data;
    },
};
